import React from 'react';
import { useParams } from 'react-router-dom';

import { WorkspaceLayout } from '../../shared/components/Layout';
import { useList } from './hooks';
import MessageForm from './components/MessageForm';
import MessageList from './components/MessageList';

import styles from '../../shared/styles/_layout.module.scss';

const Conversation = () => {
  const { taskId } = useParams();

  const { fetchMessages, isLoading: isLoadingList, messages } = useList(taskId);

  return (
    <WorkspaceLayout>
      <h1 className={styles.dashboard__title}>Conversation</h1>
      <MessageList isLoading={isLoadingList} messages={messages} />
      <MessageForm fetchMessages={fetchMessages} taskId={taskId} />
    </WorkspaceLayout>
  );
};

export default Conversation;
